import * as React from 'react'
import { generatePath, useHistory } from 'react-router-dom'

import { DOC_INSIGHTS_PATH } from 'paths'
import Styles from './ActivityEvent.module.scss'
import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/readReceipt.svg'

import { ActivityEventPosition, ArticleAllTasksMarkedAsReadEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: ArticleAllTasksMarkedAsReadEvent
}

const ArticleAllTasksMarkedAsRead = ({ event, ...props }: Props) => {
  const {
    data: { task_count },
    article: { slug },
  } = event

  const history = useHistory()

  const openInsights = (e: React.MouseEvent) => {
    e.stopPropagation()
    history.push(generatePath(DOC_INSIGHTS_PATH, { slug }))
  }

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={
        <>
          <span className={Styles.name}>
            All {task_count} of {task_count}
          </span>{' '}
          people marked as read:{' '}
          <div className={Styles.link} onClick={openInsights}>
            Open Insights
          </div>
        </>
      }
    />
  )
}

export { ArticleAllTasksMarkedAsRead }
